import { LineChart as LineIcon } from 'lucide-react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { Money } from '../../../components/ui/Money';
import { Card, CardContent } from '../../../components/ui/Card';
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../../../lib/locale';
import type { PeriodOption } from '@repo/shared-dashboard';

interface TodayCollectionWidgetProps {
  period?: PeriodOption;
}

const titles: Record<PeriodOption, string> = {
  today: "Today's Collection",
  week: "This Week's Collection",
  month: "This Month's Collection",
  quarter: "This Quarter's Collection",
  year: "This Year's Collection",
};

export function TodayCollectionWidget({ period = 'month' }: TodayCollectionWidgetProps) {
  const query = useStaffDashboard(period);
  const title = titles[period] ?? "Today's Collection";

  return (
    <DataView query={query} isEmpty={() => false}>
      {(data) => {
        const amountPaise = data?.periodCollectionPaise ?? data?.todaysCollectionPaise ?? 0;
        return (
          <Card className="bg-surface-1 border-border relative overflow-hidden transition-all hover:border-border-strong">
            <CardContent className="p-6">
              <div className="relative z-10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div>
                  <p className="text-xs font-semibold text-text-secondary uppercase tracking-wider">{title}</p>
                  <Money
                    paise={amountPaise}
                    currency={DEFAULT_CURRENCY}
                    locale={DEFAULT_LOCALE}
                    emphasis="hero"
                    className="mt-1 block text-text-primary font-inter"
                  />
                </div>
                <span className="px-3 py-1.5 bg-surface-2 rounded-[6px] text-xs font-medium text-text-secondary border border-border transition flex items-center gap-1.5 cursor-default">
                  <LineIcon className="w-4 h-4 text-accent-500" />
                  Settled Collections Only
                </span>
              </div>
            </CardContent>
          </Card>
        );
      }}
    </DataView>
  );
}

